<script>
import adminTable from './mixins/adminTable'
import axios from 'axios'
export default
{
  name: 'NewsEditor',

  mixins: [ adminTable ],

  methods:
  {
      fetch()
      {
          if (this.$route.params.id)
          {
            this.formEdit = true
            axios.get(process.env.API_URL + `/v1/admin/posts/${this.$route.params.id}`).then(({ data }) => {
                this.model = data
            })

          } else {
              this.formEdit = false
              this.model = JSON.parse(JSON.stringify(this.emptyModel))
          }

      },

      closeForm()
      {
          this.$router.go(-1)
      }
  },

  data()
  {
        return {
            model: {},
            formEdit: false,
            url: '/v1/admin/posts',
            tableName: 'tableNews',
            emptyModel: { title: null, excerpt: null, content: null, attachments: [], videos: [], is_media: false, type: 'news', slug: null, pinned: false, cover_id: null },
        }
  }

}
</script>

<template>
<div class="panel panel-primary">
    <div class="panel-heading">
        <div>{{ $t('MENU.POST') }}</div>
    </div>
    <div class="panel-body">
        <mv-news-form :model="model" :edit="formEdit" @save="saveForm"></mv-news-form>
    </div>
    <div class="panel-footer">
        <div class="text-right">
            <button class="btn btn-success" @click="$router.go(-1)">{{ $t('GENERAL.CANCEL') }}</button>
            <button v-if="model.id && model.is_published" class="btn btn-warning" @click="unpublishForm">{{ $t('POST.UNPUBLISH') }}</button>
            <button v-if="model.id && !model.is_published" class="btn btn-success" @click="publishForm">{{ $t('POST.PUBLISH') }}</button>
            <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
        </div>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/NewsEditor.vue